import type { Module } from 'vuex';
import { UserTelegramConnectionEvent } from '@/types/UserTelegramConnectionEvent';
import {RootState} from "@/store";

export interface UserTelegramConnectionEventState {
  userTelegramConnectionEvents: UserTelegramConnectionEvent[];
}

const userTelegramConnectionEventModule: Module<UserTelegramConnectionEventState, RootState> = {
  namespaced: true,

  state: () => ({
    userTelegramConnectionEvents: [],
  }),

  mutations: {
    setUserTelegramConnectionEvents(state, payload) {
      state.userTelegramConnectionEvents = Object.values(payload.userTelegramConnectionEvents).map(UserTelegramConnectionEvent.fromRaw);
    },

    addUserTelegramConnectionEvent(
      state: UserTelegramConnectionEventState,
      payload: {
        idUserTelegramConnectionEvent: number;
        idUser: number;
        eventType: string;
        token: string | null;
        chatId: number | null;
        username: string | null;
        firstName: string | null;
        lastName: string | null;
        languageCode: string | null;
        createdAt: string;
      }
    ) {
      const raw = { ...payload };
      const event = UserTelegramConnectionEvent.fromRaw(raw);

      state.userTelegramConnectionEvents.push(event);
    },
  },

  actions: {
    wsSetUserTelegramConnectionEvents(context, payload) {
      context.commit('setUserTelegramConnectionEvents', payload);
    },
    wsUserTelegramConnectionEventCreate(context, payload) {
      context.commit('addUserTelegramConnectionEvent', payload);
    },
  },
};

export default userTelegramConnectionEventModule;
